import {
	_post,
	_get
} from "@/axios/func";
import Config from "@/config";
const state = {
	menu: [
		{
			icon: require('../../assets/icon/menu-home.png'),
			iconActive: require('../../assets/icon/menu-home-active.png'),
			name: '需求管理',
			path: '/demand',
            parentId: 0,
            id: 1,
			children: [
				{
					name: '需求列表',
					path: '/demand/index',
                    parentId: 1,
                    id: 10,
                    children: []
				}
			]
		},
        {
			icon: require('../../assets/icon/menu-goodsOrder.png'),
			iconActive: require('../../assets/icon/menu-goodsOrder-active.png'),
			name: '供应管理',
			path: '/supply',
            parentId: 0,
            id: 2,
			children: [
				{
					name: '供应列表',
					path: '/supply/index',
                    parentId: 2,
                    id: 20,
                    children: []
				}
			]
		},
        {
			icon: require('../../assets/icon/menu-customer.png'),
			iconActive: require('../../assets/icon/menu-customer-active.png'),
			name: '合作意向',
			path: '/cooperation',
            parentId: 0,
            id: 3,
			children: [
				{
					name: '合作意向列表',
					path: '/cooperation/index',
                    parentId: 3,
                    id: 30,
                    children: []
				}
			]
		},
        {
			icon: require('../../assets/icon/menu-userMGT.png'),
			iconActive: require('../../assets/icon/menu-userMGT-active.png'),
			name: '用户管理',
			path: '/user',
            parentId: 0,
            id: 4,
			children: [
				{
					name: '用户列表',
					path: '/user/index',
                    parentId: 4,
                    id: 40,
                    children: []
				}
			]
		},
        {
			icon: require('../../assets/icon/menu-revenue.png'),
			iconActive: require('../../assets/icon/menu-revenue-active.png'),
			name: '资产评估',
			path: '/property',
            parentId: 0,
            id: 5,
			children: [
				{
					name: '资产评估列表',
					path: '/property/index',
                    parentId: 5,
                    id: 50,
                    children: []
				}
			]
		},
	],
	routeHis: [],
    menuList: []
}
const mutations = {
	setMenu: (state, menu) => {
		state.menu.splice(0)
		menu.map(item => {
			state.menu.push(item)
		})
	},
    setMenuId: (state, menuList) => {
		state.menuList = menuList;
	},
	
	addRouteHis: (state, route) => {
		state.routeHis.push(route)
	},

}

const actions = {
	setMenu({
		commit
	}, data) {
		commit('setMenu', data)
	},
    setMenuId({
		commit
	}, data) {
		commit('setMenuId', data)
	},
	addRouteHis({
		commit
	}, data) {
		commit('addRouteHis', data)
	},
	
	getMenu({
		commit
	}, data) {
		return new Promise(async (resolve, reject) => {

			try {
				let arg = {
					url: Config.apiUrl.getUserMenu,
					showLoading:false,
				};
				const {
					result
				} = await _get(arg)
				if (result.code === 0) {
                    let menuIdObj = {}
                    let menuIdList = []
                    result.data.map(item=>{
                        menuIdObj[item.id] = item.children.map(ite=>{
                            return ite.id
                        })
                        menuIdObj[item.id].push(item.id)
                    })
                    for(let key in menuIdObj) {
                        let item = menuIdObj[key]
                        menuIdList = menuIdList.concat(item)
                    }
					commit('setMenu', result.data);
					commit('setMenuId', menuIdList);
				} else {
					this.$message.error(result.msg || result.message)
				}
	
				resolve(result.data)
			} catch (err) {
				reject(err)
			}
		
		})
	},
}


export default {
	namespaced: true,
	state,
	actions,
	mutations
}
